import React from 'react';
import {Layout} from 'antd';

import DefaultLayout from 'components/DefaultLayout';
import UserManual from 'pages/System/UserManual';
import {UserManualType} from 'pages/System/UserManual/types';

const {Content} = Layout;

interface ManualTabProps {
    type: UserManualType;
    canEdit: boolean;
}

// One component for all three manual tabs (student/supervision/lector) -
// the class name it renders (e.g. 'student-manual-content') matches what
// styles.scss already targets for each type.
const ManualTab: React.FC<ManualTabProps> = ({type, canEdit}) => (
    <>
        <hr className='form-group-separator'/>
        <Content className={`${type.toLowerCase()}-manual-content`}>
            <DefaultLayout.PageContent className='m-2'>
                <UserManual type={type} canEdit={canEdit} />
            </DefaultLayout.PageContent>
        </Content>
    </>
);

export default ManualTab;
